<script lang="ts">
  // Xert wordmark for the corner of every report.
  export let light = false
  export let height = 40
  export let tagline = ''

  // The V3 logos, 1027.3 x 309.8.
  const LOGO_BLACK = '/assets/images/logos/XertLogosV3/Xert%20V3%20Logo%20-%20Black.svg'
  const LOGO_WHITE = '/assets/images/logos/XertLogosV3/Xert%20V3%20Logo%20-%20White.svg'
</script>

<div class="xr-brand" class:xr-light={light}>
  <img src={light ? LOGO_BLACK : LOGO_WHITE} alt="Xert" style="height: {height}px; width: {(height * 1027.3) / 309.8}px;" />
  {#if tagline}<span class="xr-tagline">{tagline}</span>{/if}
</div>

<style>
  .xr-brand {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .xr-brand img {
    display: block;
    max-width: none;
    filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.35));
  }
  .xr-light img {
    filter: none;
  }
  .xr-tagline {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--muted);
  }
</style>
